export const hasTheRightDistributionList = (poi: Pick<Area, 'distributionLists'>, user?: UserSelf) =>
  !poi.distributionLists ||
  !user ||
  poi.distributionLists.filter((l) => l !== '' && l !== null).length === 0 ||
  poi.distributionLists.some((d) => user.distributionGroups!.some((group) => group === d))
